import { Button } from '@cian/ui-kit/button';
import { FC } from 'react';

import img from '../assets/door.png';
import style from './Promo.css';
import { useDeviceType } from '@cian/ui-kit';

export const Promo: FC = () => {
  const isMobile = useDeviceType() !== 'desktop';

  return (
    <section className={style['promo']}>
      <div className={style['inner']}>
        <div className={style['content']}>
          <h2 className={style['title']}>
            Наклейка
            <br />
            Суперхозяин
          </h2>
          <div>
            <p className={style['description']}>Это знак качества, который:</p>
            <ul className={style['list']}>
              <li>подчёркивает ваш профессионализм</li>
              <li>вызывает доверие у новых гостей</li>
              <li>помогает выделиться среди конкурентов</li>
            </ul>
          </div>
          <div className={style['button-wrapper']}>
            <Button
              theme="fill_primary"
              size={isMobile ? 'M' : 'L'}
              fullWidth
              onClick={() => document.getElementById('form-step')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Получить наклейку
            </Button>
          </div>
        </div>
        <div className={style['img-container']}>
          <img className={style['img']} src={img} alt="" />
        </div>
      </div>
    </section>
  );
};
